import { useContext } from 'react';
import { Page, PageHeader } from 'components';
import { Filters, Results } from './components';
import DealersProvider from './DealersContext';
import { appUserContext } from 'helpers/services';


let Dealers = () => {
    let { currentUser } = useContext(appUserContext);

    return (
        <Page>
            <PageHeader
                addNewUrl={currentUser?.canAddDealers ? '/dealer/addnew' : undefined}
                pageTitle="Dealers"
            />
            <DealersProvider>
                <Filters />
                <Results />
            </DealersProvider>
        </Page>
    )
}

export default Dealers;